import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  LoginCacheMessageResponse,
  LoginDetailsCacheDto,
} from "../models/login-cache.model";
import { SessionCacheApiService } from "./session-cache-api.service";

@Injectable({
  providedIn: "root",
})
export class LoginCacheService {
  private readonly sessionCacheApi = inject(SessionCacheApiService);
  private readonly cacheType = "logdetails";

  set(
    sessionId: string | number,
    payload: LoginDetailsCacheDto
  ): Observable<LoginCacheMessageResponse> {
    return this.sessionCacheApi.set(this.cacheType, sessionId, payload);
  }

  get(sessionId: string | number): Observable<LoginDetailsCacheDto> {
    return this.sessionCacheApi.get<LoginDetailsCacheDto>(this.cacheType, sessionId);
  }

  remove(sessionId: string | number): Observable<LoginCacheMessageResponse> {
    return this.sessionCacheApi.remove(this.cacheType, sessionId);
  }
}
